export const allPromiseSettled = (promises) => {
  if (!Promise) {
    throw new Error('Promise is not defined');
  }
  if (!Promise.allSettled || typeof Promise.allSettled !== 'function') {
    return Promise.all(
      promises.map(function promiseToSettle(promise) {
        return promise
          .then(function settledPromiseResults(value) {
            return { state: 'fulfilled', value };
          })
          .catch(function settledPromiseResults(error) {
            return { state: 'rejected', reason: error };
          });
      }),
    );
  }
  return Promise.allSettled(promises);
};
